import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const data1 = [
  {
    type: "EV",
    fuelCost: 0,
    co2e: 0,
    fuelCostColor: "#F9A21B",
  },
  {
    type: "ICE",
    fuelCost: 0,
    co2e: 0,
    fuelCostColor: "#0F1B2B",
  },
];

const formatYAxis = (tick: number) => {
  return `${tick / 1000}K`;
};

export interface BarChartData {
  type: string;
  fuelCost: number;
  co2e: number;
  fuelCostColor: string;
}

export interface FuelCostEmissionsChartProps {
  data: BarChartData[];
  label: string;
}

const FuelCostEmissionsChart: React.FC<FuelCostEmissionsChartProps> = ({
  data = data1,
  label,
}) => {
  return (
    <div style={{ width: "100%", height: 350 }}>
      <h3 style={{ fontWeight: "bold", marginLeft: 10 }}>{label}</h3>
      <ResponsiveContainer width="100%" height="90%">
        <BarChart data={data} margin={{ right: 20 }}>
          <XAxis dataKey="type" tick={{ fontWeight: "bold" }} />
          <YAxis tickFormatter={formatYAxis} />
          <Tooltip />
          <Bar dataKey="fuelCost" fill="#F9A21B" barSize={90}>
            {data.map((entry, index) => (
              <Cell key={`cell-fuel-${index}`} fill={entry.fuelCostColor} />
            ))}
          </Bar>

          <Bar dataKey="co2e" fill="#191A1C" barSize={10} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FuelCostEmissionsChart;
